import { useTranslation } from 'react-i18next';
import CountUp from '@/components/CountUp';

export default function StatStrip() {
  const { t } = useTranslation('home');
  const labels = t('proof.stats', { returnObjects: true });

  return (
    <div
      className="grid grid-cols-2 md:grid-cols-4 border-y border-black/10 divide-y md:divide-y-0 md:divide-x divide-black/10"
      data-testid="stat-strip"
    >
      <StatCell prefix="" target={30} suffix="+" label={labels[0]} />
      <StatCell prefix="" target={60} suffix="+" label={labels[1]} />
      <StatCell prefix="£" target={150} suffix="m+" label={labels[2]} />
      <StatCell prefix="" target={100} suffix="+" label={labels[3]} />
    </div>
  );
}

function StatCell({ prefix, target, suffix, label }) {
  return (
    <div className="px-6 py-10 md:py-12 text-left">
      <p className="font-display text-[40px] md:text-[56px] leading-none font-semibold text-brand-primary tracking-tight">
        <CountUp prefix={prefix} target={target} suffix={suffix} />
      </p>
      <p
        className="mt-4 text-[11px] md:text-[12px] text-brand-accent font-medium uppercase min-h-[2.75rem]"
        style={{ letterSpacing: '0.14em' }}
      >
        {label}
      </p>
    </div>
  );
}
